module.exports = __webpack_public_path__ + "img/andrew-johnson.4aa66cc9.png";